import { generatePath, Redirect, Route, RouteProps } from "react-router";
import { useAppSelector } from "../app/hooks";
import { appPath, paramName } from "./AppRoute";

export function CouponIntroRoute(props: RouteProps) {

  const session = useAppSelector((state) => {
    return state.inputAnswer.session;
  })

  const inputPath = generatePath(
    appPath.shopqr.inputAnswer,
    {
      [paramName.surveyQestionPageIndexStr]: 0,
    }
  )

  if (session.couponInStock) {
    return <Redirect to={inputPath} />
  }

  return <Route {...props} />
}
